import React from 'react';
import { bool } from 'prop-types';
import { lazyImport } from '../../../apps/logged_out_homepage/utils/lazyImport';
import HeroBannerGerman from '../../../apps/logged_out_homepage_localized/components/HeroBannerGerman';
import Seo from '../../../apps/logged_out_homepage/shared/Seo';
import SubcategoryCarousel from '../../../apps/logged_out_homepage/components/SubcategoryCarousel';
import FrequentlyAskedQuestions from '../../../apps/logged_out_homepage_localized/components/FrequentlyAskedQuestions';
import Categories from '../../../apps/logged_out_homepage/components/Categories';
import EntryWrapper from '../../../apps/logged_out_homepage_localized/components/EntryWrapper';
import TopPriorities from '../../../apps/logged_out_homepage_localized/components/TopPriorities';
import { getSubCategories } from '../../../apps/logged_out_homepage/components/SubcategoryCarousel/config';
import { shouldLoadPersonalizedSection } from '../../../apps/logged_out_homepage_localized/components/PersonalizedSectionWrapper/shouldLoad';
import TrustBanner from '../../../apps/logged_out_homepage_localized/components/TrustBanner';
import { LAZY_COMPONENTS } from './constants';

const FiverrBusiness = lazyImport(
  LAZY_COMPONENTS.FIVERR_BUSINESS,
  () => import(/* webpackChunkName: 'FiverrBusiness' */ '../../../apps/logged_out_homepage/components/FiverrBusiness')
);

const PersonalizedSectionWrapper = lazyImport(
  LAZY_COMPONENTS.PERSONALIZED_SECTION_WRAPPER,
  () =>
    import(
      /* webpackChunkName: 'PersonalizedSectionWrapper' */ '../../../apps/logged_out_homepage_localized/components/PersonalizedSectionWrapper'
    )
);

const Freelancers = lazyImport(
  LAZY_COMPONENTS.FREELANCERS,
  () => import(/* webpackChunkName: 'Freelancers' */ '../../../apps/logged_out_homepage/components/Freelancers')
);

const HowFiverrWorksVideo = lazyImport(
  LAZY_COMPONENTS.HOW_FIVERR_WORKS,
  () =>
    import(
      /* webpackChunkName: 'HowFiverrWorksVideo' */ '../../../apps/logged_out_homepage_localized/components/HowFiverrWorksVideo'
    )
);

const QualityExpertsBanner = lazyImport(
  LAZY_COMPONENTS.QUALITY_EXPERTS_BANNER,
  () =>
    import(
      /* webpackChunkName: 'QualityExpertsBanner' */ '../../../apps/logged_out_homepage_localized/components/QualityExpertsBanner'
    )
);

const KnowledgeHub = lazyImport(
  LAZY_COMPONENTS.KNOWLEDGE_HUB,
  () =>
    import(/* webpackChunkName: 'KnowledgeHub' */ '../../../apps/logged_out_homepage_localized/components/KnowledgeHub')
);

const LoggedOutHomepageClient = ({ userWasLoggedIn, displayBrandCampaign, inProPackagesBanner }) => {
  const subCategories = getSubCategories();

  return (
    <EntryWrapper displayBrandCampaign={displayBrandCampaign} removeBottomSpace>
      <Seo />
      <HeroBannerGerman />
      <Categories />
      <div className="max-width-container">
        {shouldLoadPersonalizedSection({ userWasLoggedIn }) && <PersonalizedSectionWrapper />}
      </div>
      <SubcategoryCarousel subCategories={subCategories} />
      <div className="max-width-container">
        <HowFiverrWorksVideo />
      </div>
      <TrustBanner />
      <div className="max-width-container">
        <FiverrBusiness inProPackagesBanner={inProPackagesBanner} />
        <Freelancers />
        <KnowledgeHub />
        <FrequentlyAskedQuestions />
        <QualityExpertsBanner />
      </div>
      <TopPriorities />
    </EntryWrapper>
  );
};

LoggedOutHomepageClient.propTypes = {
  userWasLoggedIn: bool,
  displayBrandCampaign: bool,
  inProPackagesBanner: bool,
};

export default LoggedOutHomepageClient;
